import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { Image } from '@react/react-spectrum/Image'

export default function Pattern ({
    group,
    action,
    checked,
    alt,
    src
}) {
    const { dispatch, group: stateGroup, action: stateAction } = useContext(EasybakeContext)
    const isChecked = (stateGroup === group && stateAction === action)
    const className = (checked || isChecked) ? 'pattern selected' : 'pattern'
    const onClick = (checked || isChecked) ? null : (on) => dispatch({ type: 'set-action', payload: { group, action, on } })

    return (
        <Image className={className} src={src} alt={alt} onClick={onClick}/>
    )
}
